var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "monitor-table-page" } },
    [
      _c(
        "div",
        { staticClass: "monitor-table-page__header" },
        [
          _c("h2", [_vm._v(_vm._s(_vm.default_name) + "資訊")]),
          _vm._v(" "),
          _c("MonitorOptionSet", {
            ref: "monitor_option_set",
            staticClass: "monitor-table-page__option",
            attrs: { option_set: _vm.option_set },
            on: { filter_data: _vm.filter_data }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("Rainfall", {
        attrs: {
          activate_filter_by_parent: true,
          filter_value_from_parent: _vm.filtered_port
        },
        on: { collect_data: _vm.collect_data }
      }),
      _vm._v(" "),
      _c("SurfaceWeather", {
        attrs: {
          activate_filter_by_parent: true,
          filter_value_from_parent: _vm.filtered_port
        },
        on: { collect_data: _vm.collect_data }
      }),
      _vm._v(" "),
      _c("Buoy", {
        attrs: {
          default_value: 202,
          activate_filter_by_parent: true,
          filter_value_from_parent: _vm.filtered_port
        },
        on: { collect_data: _vm.collect_data }
      }),
      _vm._v(" "),
      _c("Tide", {
        attrs: {
          default_value: 205,
          activate_filter_by_parent: true,
          filter_value_from_parent: _vm.filtered_port
        },
        on: { collect_data: _vm.collect_data }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }